export const normalizeAddressSuggestionQuery = (value) => String(value || '').trim();

export const shouldFetchAddressSuggestions = ({
  visible,
  currentStep,
  query,
  suppressedQuery,
}) => {
  const normalizedQuery = normalizeAddressSuggestionQuery(query);
  const normalizedSuppressedQuery = normalizeAddressSuggestionQuery(suppressedQuery);
  if (!visible || currentStep !== 2 || normalizedQuery.length < 3) return false;
  return !normalizedSuppressedQuery || normalizedQuery !== normalizedSuppressedQuery;
};
